'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDefaultOptions = undefined;

var _generators = require('./utils/generators.js');

var getDefaultOptions = function getDefaultOptions(_) {
  return {
    name: 'Unknown',
    autoTerminate: false,
    id: {
      _: (0, _generators.generateRandomId)()
    }
  };
};
/**
 * Default options.
 * Default options for new process/
 * @module defaultOptions.js
 * @author @SurenAt93
 */


exports.getDefaultOptions = getDefaultOptions;